import { useState } from "react";
import { ContactSection } from "./styles";

const ContactPage = () => {
  const [email, setEmail] = useState("");
  const [subject, setSubject] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState(false);

  const sendEmail = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setTimeout(() => setError(true), 2000);
  };

  return (
    <ContactSection>
      <div className="left">
        <h2>Contact me:</h2>
        <p>E-mail: nicholas.ge1301@gmail.com</p>
        <p>
          <a href="https://www.linkedin.com/in/nicholas-engelbert/">
            LinkedIn.
          </a>
        </p>
        <p>
          <a href="https://github.com/nicholas1301">Github.</a>
        </p>
      </div>
      <div className="right"></div>
    </ContactSection>
  );
};

export default ContactPage;
